import React, { memo } from 'react';
import { COMMON_ERROR_WRAPPERS } from '../../../studio-blocks/components/error-wrappers/common';
import { TopHoldingsHeader } from './top-holdings-header';
import { TopHoldingsContent } from './top-holdings-content';
import { Block } from '../../components/core';

export const TopHoldingsBlock = memo(function InternalTopHoldingsBlock({ id }: { id: string }) {
  return (
    <Block.Root id={id}>
      <Block.Header>
        <TopHoldingsHeader id={id} />
      </Block.Header>

      <Block.Content id={id} errorWrappers={[...COMMON_ERROR_WRAPPERS]}>
        <TopHoldingsContent id={id} />
      </Block.Content>
    </Block.Root>
  );
});
